import { AccuracyMatchChip } from '../common/AccuracyMatchChip'
import { EmailTooltip } from './Tooltips'

const AcceptAllChip = () => (
  <AccuracyMatchChip color="warning" label="Accept-All" wrappWithTooltip={EmailTooltip} />
)

export default AcceptAllChip
